import type { ApiAssistantReply, ApiAssistantMessagePayload } from 'src/types/assistant';

import { useMutation } from '@tanstack/react-query';

import axios from 'src/utils/axios';

/**
 * One message to the storefront assistant (`POST /buyer/assistant/messages`): with the account
 * session when there is one, with none for an anonymous visitor (api#441) — the axios instance sends
 * the token only when the browser holds one. The text and, to continue, the `conversationId` of an
 * earlier reply. The conversation itself is the server's; the panel keeps only what it has shown. A turn with searches takes seconds, so the
 * read timeout of the catalog does not apply — the api's own deadline bounds it.
 */
export function useAssistantMessage() {
  return useMutation({
    mutationFn: async (payload: ApiAssistantMessagePayload): Promise<ApiAssistantReply> => {
      const response = await axios.post<ApiAssistantReply>('/buyer/assistant/messages', payload);
      return response.data;
    },
  });
}
